module.exports = __webpack_public_path__ + "img/1.27e7248d.png";